const IDTypeList = [
  { label: "大陆居民身份证", value: 1 },
  { label: "中国护照", value: 2 },
  { label: "香港居民往来内地通行证", value: 3 },
  { label: "澳门居民往来内地通行证", value: 4 },
  { label: "台湾居民往来内地通行证", value: 5 },
  { label: "香港居民居住证", value: 6 },
  { label: "澳门居民居住证", value: 7 },
  { label: "台湾居民居住证", value: 8 }
];
const otherPositionTypeInfoList = [
  { label: "外卖人员", value: "外卖人员" },
  { label: "快递人员", value: "快递人员" },
  { label: "家政人员", value: "家政人员" },
  { label: "网约车司机", value: "网约车司机" },
  { label: "网络货运司机", value: "网络货运司机" },
  { label: "代驾司机", value: "代驾司机" },
  { label: "直播人员", value: "直播人员" },
  { label: "其他", value: "其他" }
];
const positionTypeList = [
  { label: "其他", value: "其他" },
  { label: "外卖人员", value: "外卖人员" },
  { label: "快递人员", value: "快递人员" },
  { label: "家政人员", value: "家政人员" },
  { label: "网约车司机", value: "网约车司机" },
  { label: "网络货运司机", value: "网络货运司机" },
  { label: "代驾司机", value: "代驾司机" }
];

const vatItemList = [
  { code: "101016101|陆路货物运输服务", name: "101016101|陆路货物运输服务" },
  { code: "101016102|水路运输服务", name: "101016102|水路运输服务" },
  { code: "101016103|航空运输服务", name: "101016103|航空运输服务" },
  { code: "101016104|管道运输服务", name: "101016104|管道运输服务" },
  { code: "101016105|铁路运输服务", name: "101016105|铁路运输服务" },
  { code: "101016106|陆路旅客运输服务", name: "101016106|陆路旅客运输服务" },

  { code: "101016201|研发服务", name: "101016201|研发服务" },
  { code: "101016202|技术转让服务", name: "101016202|技术转让服务" },
  { code: "101016203|技术咨询服务", name: "101016203|技术咨询服务" },
  { code: "101016204|合同能源管理服务", name: "101016204|合同能源管理服务" },
  { code: "101016205|工程勘察勘探服务", name: "101016205|工程勘察勘探服务" },
  { code: "101016206|专业技术服务", name: "101016206|专业技术服务" },

  { code: "101016301|软件服务", name: "101016301|软件服务" },
  { code: "101016302|电路设计及测试服务", name: "101016302|电路设计及测试服务" },
  { code: "101016303|信息系统服务", name: "101016303|信息系统服务" },
  { code: "101016304|业务流程管理服务", name: "101016304|业务流程管理服务" },
  { code: "101016305|信息系统增值服务", name: "101016305|信息系统增值服务" },

  { code: "101016401|设计服务", name: "101016401|设计服务" },
  { code: "101016402|商标著作权转让服务", name: "101016402|商标著作权转让服务" },
  { code: "101016403|知识产权服务", name: "101016403|知识产权服务" },
  { code: "101016404|广告服务", name: "101016404|广告服务" },
  { code: "101016405|会议展览服务", name: "101016405|会议展览服务" },

  { code: "101016501|航空地面服务", name: "101016501|航空地面服务" },
  { code: "101016503|港口码头服务", name: "101016503|港口码头服务" },
  { code: "101016506|货物运输代理服务", name: "101016506|货物运输代理服务" },
  { code: "101016507|代理报关服务", name: "101016507|代理报关服务" },
  { code: "101016508|仓储服务", name: "101016508|仓储服务" },
  { code: "101016509|装卸搬运服务", name: "101016509|装卸搬运服务" },
  { code: "101016510|收派服务", name: "101016510|收派服务" },

  { code: "101016601|有形动产融资租赁", name: "101016601|有形动产融资租赁" },
  { code: "101016602|有形动产经营租赁", name: "101016602|有形动产经营租赁" },

  { code: "101016701|认证服务", name: "101016701|认证服务" },
  { code: "101016702|鉴证服务", name: "101016702|鉴证服务" },
  { code: "101016703|咨询服务", name: "101016703|咨询服务" },

  { code: "101016801|广播影视节目（作品）制作服务", name: "101016801|广播影视节目（作品）制作服务" },
  { code: "101016802|广播影视节目（作品）发行服务", name: "101016802|广播影视节目（作品）发行服务" },
  { code: "101016803|广播影视节目（作品）播映服务", name: "101016803|广播影视节目（作品）播映服务" },

  { code: "101017002|增值电信服务", name: "101017002|增值电信服务" },

  { code: "101017101|工程服务", name: "101017101|工程服务" },
  { code: "101017102|安装服务", name: "101017102|安装服务" },
  { code: "101017103|修缮服务", name: "101017103|修缮服务" },
  { code: "101017104|装饰服务", name: "101017104|装饰服务" },
  { code: "101017190|其他建筑服务", name: "101017190|其他建筑服务" },

  { code: "101017201|贷款服务", name: "101017201|贷款服务" },
  { code: "101017202|直接收费金融服务", name: "101017202|直接收费金融服务" },
  { code: "101017203|人身保险服务", name: "101017203|人身保险服务" },
  { code: "101017204|财产保险服务", name: "101017204|财产保险服务" },
  { code: "101017205|金融商品转让", name: "101017205|金融商品转让" },

  { code: "101017301|企业管理服务", name: "101017301|企业管理服务" },
  { code: "101017302|经纪代理服务", name: "101017302|经纪代理服务" },
  { code: "101017303|人力资源服务", name: "101017303|人力资源服务" },
  { code: "101017490|其他现代服务", name: "101017490|其他现代服务" },

  { code: "101017510|文化服务", name: "101017510|文化服务" },
  { code: "101017520|体育服务", name: "101017520|体育服务" },
  { code: "101017530|教育服务", name: "101017530|教育服务" },
  { code: "101017540|医疗服务", name: "101017540|医疗服务" },
  { code: "101017550|旅游服务", name: "101017550|旅游服务" },
  { code: "101017560|娱乐服务", name: "101017560|娱乐服务" },
  { code: "101017570|餐饮服务", name: "101017570|餐饮服务" },
  { code: "101017580|住宿服务", name: "101017580|住宿服务" },
  { code: "101017590|居民日常服务", name: "101017590|居民日常服务" },
  { code: "101017599|其他生活服务", name: "101017599|其他生活服务" }
];

const IDType = new Map([
  [1, "大陆居民身份证"],
  [2, "中国护照"],
  [3, "香港居民往来内地通行证"],
  [4, "澳门居民往来内地通行证"],
  [5, "台湾居民往来内地通行证"],
  [6, "香港居民居住证"],
  [7, "澳门居民居住证"],
  [8, "台湾居民居住证"]
]);
const colors = new Map([
  ["success", "#03a113"],
  ["error", "#ff4d4f"],
  ["active", "#1890ff"],
  ["abnormal", "#303133"],
  ["warning", "#F59A23"]
]);
const healthTypeList = [
  {
    label: "其他",
    value: 0
  },
  {
    label: "食品类健康证(D类)",
    value: 1
  },
  {
    label: "非食品类健康证(A类)",
    value: 2
  }
];
const healthTypeMap = new Map([
  [0, "其他"],
  [1, "食品类健康证(D类)"],
  [2, "非食品类健康证(A类)"]
]);
const qualificationTypeList = [
  {
    label: "小学",
    value: 0
  },
  {
    label: "初中",
    value: 1
  },
  {
    label: "高中",
    value: 2
  },
  {
    label: "中专",
    value: 3
  },
  {
    label: "专科",
    value: 4
  },
  {
    label: "本科",
    value: 5
  },
  {
    label: "硕士",
    value: 6
  },
  {
    label: "博士",
    value: 7
  },
  {
    label: "其他",
    value: 8
  }
];
const qualificationTypeMap = new Map([
  [0, "小学"],
  [1, "初中"],
  [2, "高中"],
  [3, "中专"],
  [4, "专科"],
  [5, "本科"],
  [6, "硕士"],
  [7, "博士"],
  [8, "其他"]
]);
const map = {
  IDType,
  colors,
  healthTypeMap,
  qualificationTypeMap
};
const positionTypeInfoList = [
  { label: "外卖人员", value: 1 },
  { label: "快递人员", value: 2 },
  { label: "家政人员", value: 3 },
  { label: "网约车司机", value: 4 },
  { label: "网络货运司机", value: 5 },
  { label: "代驾司机", value: 6 },
  { label: "直播人员", value: 7 },
  { label: "其他", value: 8 }
];

// 人岗签约状态
export const contractStatus = [
  { label: "未签署", value: 0 },
  { label: "签署中", value: 1 },
  { label: "已签署", value: 2 },
  { label: "已解约", value: 3 }
];
export const emergencyContactRelaList = [
  { label: "配偶", value: "配偶" },
  { label: "子女", value: "子女" },
  { label: "父母", value: "父母" },
  { label: "兄妹", value: "兄妹" },
  { label: "同事", value: "同事" },
  { label: "其他亲属", value: "其他亲属" },
  { label: "朋友", value: "朋友" },
  { label: "监护人", value: "监护人" },
  { label: "其他", value: "其他" }
];
export default {
  IDTypeList,
  positionTypeList,
  map,
  vatItemList,
  healthTypeList,
  qualificationTypeList,
  positionTypeInfoList,
  contractStatus,
  otherPositionTypeInfoList,
  emergencyContactRelaList
};
